import { render, staticRenderFns } from "./ztCheckBox.vue?vue&type=template&id=51bb21d0&scoped=true&"
import script from "./ztCheckBox.vue?vue&type=script&lang=js&"
export * from "./ztCheckBox.vue?vue&type=script&lang=js&"
import style0 from "../../../../styles/components/ztCheckBox.css?vue&type=style&index=0&id=51bb21d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb21d0",
  null
  
)

export default component.exports